import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import About from "../components/About";
import Gallery from "../components/Gallery";
import Videos from "../components/Videos";
import FloorPlans from "../components/FloorPlans";
import TourSection from "../components/Tour3D";
import Files from "../components/Files";
import Map from "../components/Map";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <>
      <Nav />
      <Hero />
      <About />
      <Gallery />
      <Videos />
      <FloorPlans />
      <TourSection />
      <Files />
      <Map />
      <Contact />
    </>
  );
};

export default Home;
